<template>
  <div class="toolbar-button-group d-flex">
    <div
      v-for="[id, icon, title, shortcuts, state, disabled] in buttons"
      :key="id"
      class="ml-2 mr-2 mt-3"
    >
      <ToolbarTooltip
        location="top"
        :open-delay="1000"
        :title="title"
        :shortcuts="shortcuts"
      >
        <template #activator="{ props }">
          <div v-bind="props">
            <ToolbarButton
              :active="Boolean(state)"
              :disabled="Boolean(disabled)"
              :icon-name="icon"
              @click="$emit('buttonClick', {
                id, state, disabled, $event,
              })"
            />
          </div>
        </template>
      </ToolbarTooltip>
    </div>
  </div>
</template>

<script>
import ToolbarTooltip from '@/components/document/editorToolbar/ToolbarTooltip.vue';
import ToolbarButton from './ToolbarButton.vue';

export default {
  name: 'ToolbarButtonGroup',
  components: { ToolbarButton, ToolbarTooltip },
  props: {
    buttons: { type: Array, default: () => [] },
  },
  emits: ['buttonClick'],
};
</script>
